<template>
    <label class="block text-sm font-medium text-gray-700">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot /></span>
        <span v-if="tooltip" v-tippy="tooltip" class="ml-1">
            <font-awesome-icon icon="question-circle" class="h-4 w-4" />
        </span>
    </label>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
        },
        tooltip: {
            type: String,
            required: false,
        }
    },
};
</script>